import { Order } from 'shell/view-models/order';
import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';
import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { Operation } from 'shell/view-models/operation';
import { FiltersFormReleaseMode } from 'front-office/view-models/release-mode';

export const transformDataset = (values: FiltersFormReleaseMode): string => {
  const { orders, ...otherValues } = values;

  const transformedFilters: OperationObject = {
    codiceModalitaRilascio: {
      value: otherValues.code || '',
      operation: Operation.EQUALS,
    },
    descrizione: {
      value: otherValues.description || '',
      operation: Operation.LIKE,
    },
    codiceEsenzioneAnpr: {
      value: otherValues.exemption || '',
      operation: Operation.EQUALS,
    },
    tipoRegistro: {
      value: otherValues.register || '',
      operation: Operation.EQUALS,
    },
    codiceUsoModalita: {
      value: otherValues.use || '',
      operation: Operation.EQUALS,
    },
    validitaDal: {
      value: otherValues.dateFrom ? otherValues.dateFrom?.toFormat('yyyy-MM-dd') : '',
      operation: Operation.EQUALS,
    },
    validitaAl: {
      value: otherValues.dateTo ? otherValues.dateTo?.toFormat('yyyy-MM-dd') : '',
      operation: Operation.EQUALS,
    },
  };

  const ordersToTransform = orders || {};
  const ordersMapped: Order = {
    codice: ordersToTransform.code,
    descrizione: ordersToTransform.description,
    esenzione: ordersToTransform.exemption,
    registro: ordersToTransform.register,
    usoModalita: ordersToTransform.use,
    dataDa: ordersToTransform.dateFrom,
    dataA: ordersToTransform.dateTo,
  };

  return `${paginationListToQueryString({
    filters: transformedFilters,
    orders: ordersMapped,
  })}`;
};
